import React, { useEffect } from 'react';
import './Spinner.css';

const Spinner = () => {
  useEffect(() => {
    // Hide spinner after load
    setTimeout(() => {
      const spinner = document.getElementById('spinner');
      if (spinner) {
        spinner.classList.remove('show');
      }
    }, 500);
  }, []);

  return (
    <div 
      id="spinner" 
      className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
    >
      <div 
        className="spinner-border " 
        style={{ width: '3rem', height: '3rem', color: '#DE400E' }} 
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;